export type VoiceCallTurnRole = 'user' | 'assistant';

export type VoiceCallTurn = {
  id: string;
  role: VoiceCallTurnRole;
  text: string;
  final: boolean;
};

const nextId = (turns: VoiceCallTurn[], role: VoiceCallTurnRole) =>
  `voice-${turns.length}-${role}-${Math.random().toString(36).slice(2, 8)}`;

export const upsertVoiceTurn = (
  turns: VoiceCallTurn[],
  role: VoiceCallTurnRole,
  text: string,
  final: boolean,
): VoiceCallTurn[] => {
  const last = turns[turns.length - 1];
  if (last && last.role === role && !last.final) {
    return [...turns.slice(0, -1), { ...last, text: text || last.text, final }];
  }
  if (!text.trim()) {
    return turns;
  }
  return [...turns, { id: nextId(turns, role), role, text, final }];
};

export const finalizeLastVoiceTurn = (
  turns: VoiceCallTurn[],
  role?: VoiceCallTurnRole,
): VoiceCallTurn[] => {
  const last = turns[turns.length - 1];
  if (!last || last.final || (role && last.role !== role)) {
    return turns;
  }
  return [...turns.slice(0, -1), { ...last, final: true }];
};
